import { CreateFulfillmentOrderState } from './createFulfillmentOrder.types'

const createFulfillmentOrderInitialState: CreateFulfillmentOrderState = {
  loading: false,
  error: null,
  success: null
}

export default createFulfillmentOrderInitialState
